import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class PlaceRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   */
  list(token: string, text?: string, limit?: number) {
    let url = this.network.CodaQApi() + CQWebappApi.PLACE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.TEXT, text ? text : '');

    if (limit) form.set(RequestField.LIMIT, limit.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
